import { makeStyles } from '@material-ui/core/styles';

export const dispatchDateStyles = makeStyles(() => ({
  datepicker: {
    padding: '20px 0 20px 0',
    textTransform: 'capitalize',
  },
}));
